var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container box content-container"},[(_vm.logoutSuccess)?_c('b-message',{attrs:{"type":"is-success","title":"Success","has-icon":"","closable":false}},[_vm._v(" You have been logged out. ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }